// extracted by mini-css-extract-plugin
export default {"col":"PerformanceTesting_col__DHeLU","arrow":"PerformanceTesting_arrow__9NOZl","lists":"PerformanceTesting_lists__+GFm+"};